let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6w1yT")).then(() => parcelRequire('3nNhz'));